import React from 'react';
import { motion } from 'framer-motion';

const SlidingText = () => {
  const content = "we learn your business / analyze & evolve / optimize & refine / then launch, at groviyo / ";

  const renderText = () => (
    <span className="text-4xl md:text-6xl lg:text-7xl font-bold py-12 flex">
      {content.split('/').map((text, index) => (
        <span key={index} className="mx-4">
          <span className={index % 2 === 0 ? "text-yellow-400" : "text-cyan-300"}>
            {text.trim()}
          </span>
          <span className="text-yellow-400">
            {index < content.split('/').length - 1 ? ' /' : ''}
          </span>
        </span>
      ))}
    </span>
  );

  return (
    <div className="w-full bg-gradient-to-br from-gray-50 to-gray-100 overflow-hidden py-12 relative">
      <div className="relative flex overflow-x-hidden">
        <motion.div
          initial={{ x: "0%" }}
          animate={{ x: "-50%" }}
          transition={{
            x: {
              repeat: Infinity,
              repeatType: "loop",
              duration: 20,
              ease: "linear",
            },
          }}
          className="whitespace-nowrap flex"
        >
          {renderText()}
        </motion.div>

        <motion.div
          initial={{ x: "100%" }}
          animate={{ x: "50%" }}
          transition={{
            x: {
              repeat: Infinity,
              repeatType: "loop",
              duration: 20,
              ease: "linear",
            },
          }}
          className="absolute top-0 whitespace-nowrap flex"
        >
          {renderText()}
        </motion.div>

        <div className="absolute left-0 top-0 h-full w-40 bg-gradient-to-r from-gray-50 to-transparent" />
        <div className="absolute right-0 top-0 h-full w-40 bg-gradient-to-l from-gray-50 to-transparent" />
      </div>
    </div>
  );
};

export default SlidingText;